module.exports = __webpack_public_path__ + "img/up2.8ec6b36d.png";